import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { DocumentList } from "./RequestDetailModal";
import {
  getCompanyDocuments,
  getRequestDocuments,
} from "../../redux/actions/DocumentActions";
import { getCompanyByRequest } from "../../redux/actions/CompanyActions";

function ProcedureResponseModal({ show, onHide, procedure }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState(null);

  useEffect(() => {
    const fetchDocuments = async () => {
      if (procedure && user?.token && procedure?.reference) {
        setLoading(true);
        try {
          if (procedure.type === "RegistrationRequest") {
            await dispatch(
              getCompanyByRequest(
                user.token,
                procedure.reference,
                ({ success, data }) => {
                  if (!success) setLoading(false);
                  if (success) {
                    (async () => {
                      try {
                        await dispatch(
                          getCompanyDocuments(user.token, data._id, (data) => {
                            setDocuments(Array.isArray(data) ? data : []);
                            setLoading(false);
                          }),
                        );
                      } catch (error) {
                        console.error("Erreur lors du dispatch :", error);
                      }
                    })();
                  }
                },
              ),
            );
          } else {
            await dispatch(
              getRequestDocuments(user.token, procedure.reference, (data) => {
                setDocuments(Array.isArray(data) ? data : []);
                setLoading(false);
              }),
            );
          }
        } catch (error) {
          console.error("Erreur lors du chargement des documents :", error);
          setLoading(false);
        }
      }
    };

    fetchDocuments();
  }, [procedure, user?.token, dispatch]);

  const files = (documents || []).map((document) => ({
    key: document._id || document.url,
    label: document.name,
    file: document,
  }));

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h2" className="dash-card-title mb-0">
          Réponse de nos équipes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {procedure?.comment && (
          <div className="dash-note">
            <p className="dash-pre">{procedure.comment}</p>
          </div>
        )}
        {loading ? (
          <p className="dash-loading">Chargement des documents…</p>
        ) : (
          <DocumentList documents={files} />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ProcedureResponseModal;
